export enum NAV_LINKS {
    LOGIN = "/login",
    USER_MGT = "/users",
    PLANT_MGT = "/factories",
    IE_MGT = "/IEManagement",
    STUDY_BROWSER = "/study-browser",
    REPORTS = "/reports",
    BI_REPORTS = "/bi-reports",
    PRE_STUDY_SEARCH = "/prestudy/search",
    PRE_STUDY_CREATE = "/prestudy/create",
    PRE_STUDY_SEARCH_ID = "/prestudy/search/:id",
}

export const APP_TABLE_SETTINGS = {
    DEFAULT_TABLE_PAGE_SIZE: 10,
    DEFAULT_ROWS_PER_PAGE: [10, 25, 50]
}


export const APP_STUDIES_LIST = [
    { id: 1, name: 'Potential Study' },
    { id: 2, name: 'Yamazumi Study' },
    { id: 3, name: 'Production Study' },
    { id: 4, name: 'Work Combination and Time Study' }
]

export const LAYOUT_CONFIGS = {
    DRAWER_OPENED_WIDTH: 240,
    DRAWER_COLLAPSED_WIDTH: 55
}

export enum APP_STUDIES {
    PROTENTIAL = 1,
    YAMAZUMI = 2,
    PRODUCTION = 3,
    WORK_COMBINATION_AND_TIME_STUDY = 4
}

export enum APP_EML_CATEGORY {
    MANUAL = 1,
    AUTO = 2,
    WALK = 3,
    MACHINE_TIME = 4
}

export const CHART_COLOR_PALETTE = [
    '#662e9b',
    '#f86624',
    '#fcd02a',
    '#ea3546',
    '#38afc0',
    '#00e396',
    '#cf972a',
    '#5c4742',
    '#4340e5',
    '#00c7f2',
    '#001219',
    '#ee8c00',
    '#287d8e',
    '#e9d8a6',
    '#94d2bd',
    '#3a0ca3',
    '#f72585',
    '#9e6431',
    '#506739',
    '#0fa69a',
    '#a2c432',
    '#dda15e',
    '#007200',
    '#141653',
    '#ff7274',
    '#66e9e4',
    '#7b0046',
    '#fed46e',
    '#d73306',
    '#9ef01a',
    '#c66005',
    '#a1a1a1',
    '#ff0000',
    '#8d1f1f',
    '#33aa72',
    '#ff00ff',
    '#eb86fa',
    '#455e89',
    '#39c21e',
    '#555555',
    '#513003',
    '#39b54a',
    '#bc0e59',
    '#fffc31',
    '#ee8434',
    '#09b6b4',
    '#4d194d',
    '#f94144',
    '#7796b1',
    '#c0b508',
    '#81679a',
    '#f39164',
    '#f9de76',
    '#f17f89',
    '#80bbc3',
    '#8ce9c9',
    '#d0aa61',
    '#716360',
    '#8987e3',
    '#68d8f0',
    '#1b2b31',
    '#edad51',
    '#6298a3',
    '#c8b98d',
    '#d0f6e9',
    '#5c3ca6',
    '#f279b1',
    '#aa7e57',
    '#7d8970',
    '#55b7af',
    '#b5c77b',
    '#ddba93',
    '#3a8b3a',
    '#3e406d',
    '#f8a4a6',
    '#a2ccca',
    '#7c3a60',
    '#f2d691',
    '#dc7458',
    '#c5e78e',
    '#cd813d',
    '#9e9e9e',
    '#fb9d9d',
    '#8c5151',
    '#7fae98',
    '#f77cf7',
    '#b059bd',
    '#8794aa',
    '#86c47b',
    '#b7b7b7',
    '#654c2b',
    '#93af97',
    '#b15e82',
    '#f7f69a',
    '#eca672',
    '#62b6b5',
    '#563656',
    '#eaa6a7',
    '#c4d7e8',
    '#e1d400'
]

export enum STUDY_TYPE_ABBREVIATIONS {
    POTENTIAL_STUDY = "PTNS",
    YAMAZUMI_STUDY = "YMZS",
    PRODUCTION_STUDY = "PDCS",
    WORK_COMBINATION_AND_TIME_STUDY = "WCTS"
}